import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { makeStyles } from "tss-react/mui";
import { Linked, LinkedExtended } from "@miplatform/assets";
import { MiInputTextbox, MiPlaceholderList } from "@miplatform/components";
import { Box } from "@mui/material";
import { ConfigAccordionHeader } from "../../../../../Config/components/ConfigAccordionHeader/ConfigAccordionHeader";
import { MaterialCard } from "../../../../components/MaterialCard/MaterialCard";
import { IItemData } from "../../Items.types";

export const ItemPreviewTab: FC<ItemPreviewTabProps> = ({
  form,
}: ItemPreviewTabProps) => {
  const { watch } = form;
  const { classes } = useStyles();
  const data = watch();

  return (
    <ConfigAccordionHeader title="Preview">
      <Box className={classes.previewBox}>
        <MaterialCard
          item={data}
          variant="thin"
          leftAction={
            <MiInputTextbox
              value={1}
              className={classes.inputQuantity}
              disabled
              textTruncate={false}
            />
          }
        />
        {data.linkedMaterials.length === 0 && (
          <Box className={classes.placeholderListBox}>
            <MiPlaceholderList text="No linked items." />
          </Box>
        )}
        {data.linkedMaterials.map((material, index) => {
          return (
            <Box key={material.id} className={classes.materialBox}>
              {index === 0 && (
                <img
                  src={Linked}
                  alt="linkImage"
                  className={classes.linkedImg}
                />
              )}
              {index > 0 && (
                <img
                  src={LinkedExtended}
                  alt="linkExtendedImage"
                  className={classes.LinkedExtendedImg}
                />
              )}
              <MaterialCard
                item={material}
                variant="thin"
                leftAction={
                  <MiInputTextbox
                    value={material.quantity}
                    className={classes.inputQuantity}
                    disabled
                    textTruncate={false}
                  />
                }
              />
            </Box>
          );
        })}
      </Box>
    </ConfigAccordionHeader>
  );
};

const useStyles = makeStyles()((theme) => ({
  previewBox: {
    border: `1px solid ${theme.palette.grey.accent}`,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
  },
  materialBox: {
    display: "flex",
    gap: theme.spacing(2),
  },
  placeholderListBox: {
    marginTop: theme.spacing(4),
  },
  linkedImg: {
    position: "relative",
    bottom: 8,
    left: 20,
  },
  LinkedExtendedImg: {
    position: "relative",
    bottom: 20,
    left: 20,
    marginTop: -1,
  },
  inputQuantity: {
    width: 30,
    "& .MuiInputBase-input.MuiOutlinedInput-input": {
      padding: 0,
      paddingLeft: 3,
    },
  },
}));

interface ItemPreviewTabProps {
  form: UseFormReturn<IItemData>;
}
